export default {"src":"/_next/static/media/0e09d723-bbe1-41ae-899d-be2b629ff161.6855624f.svg","height":115,"width":120};